module.exports = __webpack_public_path__ + "img/l.91233a19.jpg";